import DashboardContainer from 'Components/Dashboard/DashboardContainer';
import ErrorPage from 'Components/ErrorPage/ErrorPage';
import { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { QUERY_PARAMS } from 'Routes/profileRoutes';
import { Auth0Service } from 'Services/ServiceFactory';
import { getIsLoggedIn } from 'Utils/auth/authUtils';
import { i18nextInit } from 'Utils/localization/i18next';
import { getQueryStringValue, isValidIKEAUrl } from 'Utils/url/urlUtils';
import '../styles/common.scss';

const mode = getQueryStringValue(
  window.location.search,
  QUERY_PARAMS.TRANSLATE
);

i18nextInit(mode);

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const isErrorRoute = window.location.pathname.endsWith('/error/');

  useEffect(() => {
    if (isErrorRoute) return;
    getIsLoggedIn().then(loggedIn => {
      if (!loggedIn) {
        const from = window.location.href;
        Auth0Service.login(isValidIKEAUrl(from) ? from : undefined);
      } else {
        setIsLoggedIn(true);
      }
    });
  }, [isErrorRoute]);

  if (isErrorRoute) return <ErrorPage />;
  if (!isLoggedIn) return null;
  return (
    <Switch>
      <Route path="/error/" component={ErrorPage} />
      <Route path="/" component={DashboardContainer} />
    </Switch>
  );
};

export default App;
